<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="account-profile-content">
	<div class="account-profile-form-container">
		<h1>{{ appStrings.PROFILE_PAGE_TITLE }}</h1>
		<password-policy-list *ngIf="!(isSSO$ | async)" class="password-policy-mobile"></password-policy-list>
		<form class="account-profile-form" [formGroup]="userForm" (ngSubmit)="onSubmit()">
			<ng-container formGroupName="userData">
				<!-- Email -->
				<mat-form-field>
					<mat-label>{{ appStrings.EMAIL }}</mat-label>
					<input matInput formControlName="email" readonly />
				</mat-form-field>
			</ng-container>

			<ng-container formGroupName="passwords" *ngIf="!(isSSO$ | async)">
				<!-- Current Password -->
				<mat-form-field>
					<mat-label>{{ appStrings.PROFILE_CURRENT_PASSWORD }}</mat-label>
					<input type="password" matInput formControlName="currentPassword" />
				</mat-form-field>

				<!-- New Password -->
				<mat-form-field>
					<mat-label>{{ appStrings.PROFILE_NEW_PASSWORD }}</mat-label>
					<input
						type="password"
						matInput
						formControlName="newPassword"
						[errorStateMatcher]="newPasswordErrorMatcher"
					/>
					<mat-error *ngIf="newPassword.hasError('required')">{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
					<mat-error *ngIf="!newPassword.hasError('required') && newPassword.hasError('minlength')">{{
						appStrings.PASSWORD_ERROR_MIN
					}}</mat-error>
					<mat-error
						*ngIf="
							!newPassword.hasError('required') &&
							!newPassword.hasError('minlength') &&
							newPassword.hasError('notMatchRequirements')
						"
						>{{ appStrings.PASSWORD_ERROR_PATTERN }}</mat-error
					>
				</mat-form-field>

				<!-- Confirm New Password -->
				<mat-form-field>
					<mat-label>{{ appStrings.SIGN_UP_FORM_CONFIRM_PASSWORD }}</mat-label>
					<input
						type="password"
						matInput
						formControlName="confirmPassword"
						[errorStateMatcher]="confirmPasswordErrorMatcher"
					/>
					<mat-error>{{ appStrings.CONFIRM_PASSWORD_ERROR }}</mat-error>
				</mat-form-field>
			</ng-container>

			<ng-container formGroupName="userData">
				<!-- First Name -->
				<mat-form-field>
					<mat-label>{{ appStrings.SIGN_UP_FORM_FIRST_NAME }}</mat-label>
					<input matInput formControlName="firstName" />
					<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<!-- Last Name -->
				<mat-form-field>
					<mat-label>{{ appStrings.SIGN_UP_FORM_LAST_NAME }}</mat-label>
					<input matInput formControlName="lastName" />
					<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<!-- Company -->
				<mat-form-field>
					<mat-label>{{ appStrings.SIGN_UP_FORM_COMPANY }}</mat-label>
					<input matInput formControlName="company" />
					<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<!-- Phone -->
				<mat-form-field>
					<mat-label>{{ appStrings.SIGN_UP_FORM_TELEPHONE }}</mat-label>
					<input matInput formControlName="phone" />
					<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<!-- Zip -->
				<mat-form-field>
					<mat-label>{{ appStrings.PROFILE_ZIP_CODE }}</mat-label>
					<input matInput formControlName="zip" />
					<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
				</mat-form-field>

				<!-- Title -->
				<mat-extended-select
					[option$]="titleFields$"
					[valuePath]="['value']"
					[placeholder]="appStrings.PROFILE_TITLE_PLACEHOLDER"
					formControlName="title"
					[required]="true"
				/>
			</ng-container>

			<!-- Buttons -->
			<button-footer [saveOrCloseButtonText]="appStrings.PROFILE_NEXT_BTN">
				<button leftButton type="button" (click)="goBack()" mat-stroked-button color="primary">
					{{ appStrings.UICONTROL_TEXT_CANCEL }}
				</button>
			</button-footer>
		</form>
	</div>
	<password-policy-list *ngIf="!(isSSO$ | async)" class="password-policy"></password-policy-list>
</div>
